import { render } from "./TestInputPage.vue?vue&type=template&id=2e7498f2"
import script from "./TestInputPage.vue?vue&type=script&lang=js"
export * from "./TestInputPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__